// extracted by mini-css-extract-plugin
var _1 = "BnnaXU4st37A68UK6i51";
var _2 = "KeQhWPcyAFrq5wbUScJw";
export { _1 as "textAlert", _2 as "textBold" }
